import { useState } from 'react'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Autocomplete from '@mui/material/Autocomplete'
import { useTranslation } from 'react-i18next'
import {
  useAddCarMutation,
  useSearchUsersQuery
} from '@/api'

const CarDialogForm = ({ open, onClose }) => {
  const { t } = useTranslation()
  const [plateNumber, setPlateNumber] = useState('')
  const [brand, setBrand] = useState('')
  const [model, setModel] = useState('')
  const [year, setYear] = useState('')
  const [userId, setUserId] = useState('')
  const [search, setSearch] = useState('')
  const [selectedUser, setSelectedUser] = useState(null)

  const { data: users = [], isLoading } = useSearchUsersQuery(search, {
    skip: !search
  })

  const [createCar] = useAddCarMutation()

  const handleSubmit = async () => {
    try {
      await createCar({
        plate_number: plateNumber,
        brand,
        model,
        year: parseInt(year, 10),
        user_id: selectedUser?.id
      }).unwrap()
      onClose()
    } catch (err) {
      console.error('❌ Ошибка при добавлении авто:', err)
    }
  }

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t('add_a_car')}</DialogTitle>
      <DialogContent>
        <TextField
          label={t('number')}
          fullWidth
          margin="dense"
          value={plateNumber}
          onChange={(e) => setPlateNumber(e.target.value)}
        />
        <TextField
          label={t('brand')}
          fullWidth
          margin="dense"
          value={brand}
          onChange={(e) => setBrand(e.target.value)}
        />
        <TextField
          label={t('vehicle_model')}
          fullWidth
          margin="dense"
          value={model}
          onChange={(e) => setModel(e.target.value)}
        />
        <TextField
          label={t('year')}
          fullWidth
          margin="dense"
          type="number"
          value={year}
          onChange={(e) => setYear(e.target.value)}
        />
        <Autocomplete
          options={users}
          getOptionLabel={(option) =>
            `${option.first_name || ''} ${option.last_name || ''} (${
              option.phone_number || ''
            })`
          }
          loading={isLoading}
          onInputChange={(_, value) => setSearch(value)}
          onChange={(_, newValue) => setSelectedUser(newValue)}
          renderInput={(params) => (
            <TextField {...params} label={t('user')} margin="dense" fullWidth />
          )}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('cancellation')}</Button>
        <Button onClick={handleSubmit} variant="contained">
          {t('save')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default CarDialogForm
